import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Product } from 'src/app/models/app.models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-product-type16',
  templateUrl: './product-type16.component.html',
  styleUrls: ['./product-type16.component.scss']
})
export class ProductType16Component implements OnInit {
  commonService: any;
  form_validation_messages = {

    'phone': [
      { type: 'required', message: 'Please fill out this field.' },
      { type: 'minlength', message: 'Enter a Valid Number' },
      { type: 'maxlength', message: 'Enter a Valid Number' },
    ],

    }
  ngOnInit(): void {
    console.log(this.product);
    console.log(this.spec);
  }
  @Input() selection:any=[]
  @Input() productDetailPage: any;

  @Input() productCustomOption: any;

  @Input() data: any;

  @Input() name: any;

  @Input() response: any;

  @Input() reviewDetail: any

  @Input() relatedProductsList: any;

  @Input() upSellsProductsList: any;

  @Input() crossSellsProductsList: any

  @Input() recentlyViewedProducts: any;

  @Input() displayColdChain: boolean;
  @Input() deliveryDoorStepIcon: any;
  @Input() showTimeIcon: any;
  @Input() showGenuineProductIcon: any;
  @Input() genuineProductText: any;
  @Input() deliveryTime: any;
  @Input() deliveryDoorStepText: any;
  @Input() ColdChain: any;
  @Input() product: any;
  @Input() guestLogin: any;
  @Input() videourl: any;
  @Input() videoAvaliable: boolean;
  @Input() isInStock: any;
  @Input() qty: any;
  @Input() manageStock: any;
  @Input() factBox: any;
  @Input() faq: any;
  @Input() SIDEEFFECTS: any;
  @Input() Commonsideeffects: any;
  @Input() SafetyAdvice: any;
  @Input() HOWTOUSE: any;
  @Input() UsesOf: any;
  @Input() Benefits: any;
  @Input() HowWorks: any;
  @Input() Ifmiss: any;
  @Input() productName: any;
  @Input() PregnancyInteraction: any;
  @Input() BreastfeedingInteraction: any;
  @Input() DrivingInteraction: any;
  @Input() KidneyInteraction: any;
  @Input() LiverInteraction: any;
  @Input() MANUFACTURER: any;
  @Input() SALTCOMPOSITION: any;
  @Input() STORAGES: any;
  @Input() factbox: any;
  @Input() spec: any;
  @Input() showNewConfig: boolean = false;
  @Input() units: any;
  @Input() discountPercentage: any;
  @Input() price: number;
  @Input() specialPrice: any;
  @Input() averageRating: any;
  @Input() calculateAvgRating: any
  @Input() prescriptionRequired: boolean = false;
  @Input() imageList: any;
  @Input() productDetailImageWidth:any=50;
  @Input() productzoom: any;
  @Input() productIdAddedInCart: any = {};
  @Input() configattributeType: any;
  @Input() firstIndex: any;
  @Input() secondIndex: any;
  @Input() configurationDropDownList = new Map<any, any>();
  @Input() dropDownValue = new UntypedFormControl('');
  @Input() configProductSelected: any;
  @Input() configProduct: any;
  @Input() showExclusivePrice: number;
  @Input() managePriceSeperately: number;
  @Input() maintainStockIndConfProduct: number;
  @Input() manageAdditionalInformationSeperately: number;
  @Input() manageDescriptionSeperately: number;
  @Input() manageNameSeperately: number;
  @Input() description: any;
  @Input() manageImageSeperately: number;
  @Input() bigImage: string;
  @Input() alcoholInteraction: any;
  @Input() commonImageApi: any;
  @Input() relatedProductsText: any;
  @Input() upSellProductsText: any;
  @Input() crossSellProductsText: any;
  @Input() recentlyViewedProductsText: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() categoryArray: any;
  @Input() indexConfig: any = 0;
  @Input() productImageWidth: any;
  @Input() productImageType: any;
  @Input() productImageWidthMob: any;
  @Input() productImageHeightMob: any;
  @Input() productImageHeight: any;
  @Input() showConfigurableDropdown: any;
  @Input() buttonArray: any = [];
  @Input() productDetailHeightMobile: any;
  @Input() productDetailWidthMobile: any;
  @Input() productDetailHeight: any;
  @Input() productDetailWidth: any;
  @Input() coversionTrackingIdGa:any;
  enableEnquire: any = 0;
  disablePriceInDetailPage: any = 1;
  @Input() sizeChartId: any;
  @Input() MapLink: any;


  public serverPath7 = environment.commonImageApi+"catalog/product";



  @ViewChild('shareProduct') shareProduct: TemplateRef<any>;

  @ViewChild('zoomViewer', { static: true }) zoomViewer;

  @Input() image: any;
  @Input() zoomImage: any;
  @Input() sub: any;
  @Input() form: UntypedFormGroup;
  @Input() relatedProducts: Array<Product>;
  @Input() filterRequest: any;
  @Input() images: Object;
  @Input() query: any;
  @Input() documentId: any;
  @Input() configurableProductId: any;
  @Input() event: any;
  b2bPricingEnabled: string | number;
  initalArray: any[];
  Layout: any;
  @Input() public pageTitle: any
  @Input() public homePageBuilder: any;
  layoutype: any;
  init: boolean;

 

   

  property = {
    price: '85.0 Lac',
    emi: '38k',
    area: '1090',
    bhk: '3',
    location: 'Chromepet, Chennai',
    image: 'path_to_image.jpg', // Update the path to the actual image
    beds: '3',
    baths: '2',
    balconies: '1',
    furnishedStatus: 'Unfurnished',
    status: 'Ready to Move',
    facing: 'North',
    ownershipType: 'Freehold',
    lastContact: '1 day ago',
    registrationCharges: '6,80,000',
    address: 'central bank colony chrompet, Chromepet, Chennai - South, Tamil Nadu',
    landmarks: 'Very close to GST, railway station, schools and college',
    furnishing: 'Unfurnished',
    description: 'New constructed north facing 3BHK apartment perfect for family',
    rows: [
      [
        { key: 'Super Built-Up Area', value: '1090 sqft', subvalue: '₹7,798/sqft' },
        { key: 'Floor', value: '2 (Out of 2 Floors)' },
        { key: 'Transaction Type', value: 'Resale' }
      ]
    ]
  };
  toggleButtonColor(event: any, isHover: boolean) {
    event.target.style.backgroundColor = isHover ? '#c82333' : '#dc3545';
  }
  city ={
    name: "Chrompet",
    rating: 4.1,
    reviews : 117,
    rank: 137,
    totalLocalities:5196,
    attributes: {
      environment: 3.9,
      commuting: 4,
      placesOfInterest: 4.5
    },
    cards :[
      {
        title: 'Educational Institutes',
        items: ['Madras Institute of Technology', 'Madras Christian College']
      },
      {
        title: 'Transportation Hubs',
        items: ['Chromepet Railway Station', 'Chromepet Railway Station']
      },
      {
        title: 'Shopping Centers',
        items: ['Magesh Hyper market', 'Vetri Theatres']
      }
      ,
      {
        title: 'Shopping Centers',
        items: ['Magesh Hyper market', 'Vetri Theatres']
      }
      ,
      {
        title: 'Shopping Centers',
        items: ['Magesh Hyper market', 'Vetri Theatres']
      }
      
      
    ],
    description: 'Chromepet is densely populated residential locality situated in the Southern part of Chennai...',
    moreText: 'It is located adjacent to the Great Southern Trunk Road (GST). The locality is dominated by the horizontal development of low to mid-rise builder’s floor. Excellent connectivity with nearby IT hubs is a key driver of residential demand in Chromepet. Nearby established localities include Tambaram, Medavakkam, and Kovilambakkam. Prominent projects in the locality include Royal Castle, Palm Riviera, and Alsa Green Park.',
  }
  showMore: boolean = false;


  // get transform(): string {
  //   return `translateX(-${this.currentIndex * 100}%)`;
  // }

  toggleShowMore() {
    this.showMore = !this.showMore;
  }
 
  currentIndex = 0;
  visibleCards = 3;  // Number of cards to show at a time

  get transform() {
    return `translateX(-${this.currentIndex * (100 / this.visibleCards)}%)`;
  }

  slideLeft() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  slideRight() {
    if (this.currentIndex < this.city.cards.length - this.visibleCards) {
      this.currentIndex++;
    }
  }
  generateWhatsAppMessage() {

    let message = `Hi, I'm interested in buying the ${this.product.name}.\n`;
    message += `Can you please provide more information about it, including the price?`;
    const url = `https://api.whatsapp.com/send?phone= ${encodeURIComponent(this.data.storePhoneNumber)}&text=${encodeURIComponent(message)}`;
    this.commonService.goToLink(url)
  }

  public onMouseMove(e) {


    if (window.innerWidth >= 1280) {
      var image, offsetX, offsetY, x, y, zoomer;
      image = e.currentTarget;
      offsetX = e.offsetX;
      offsetY = e.offsetY;
      x = offsetX / image.offsetWidth * 100;
      y = offsetY / image.offsetHeight * 100;
      zoomer = this.zoomViewer.nativeElement.children[0];
      if (zoomer) {
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
        zoomer.style.display = "block";
        zoomer.style.height = image.height + 'px';
        zoomer.style.width = image.width + 'px';
      }
    }
  }

  public onMouseLeave(event) {
   
    if(this.zoomViewer.nativeElement.children.length>0){
      this.zoomViewer.nativeElement.children[0].style.display = "none"; 
    }
  
  }
  setZoomImage(event) {
    this.zoomImage = event

  }

 }
